import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinRemovedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="coin_removed_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666V640a42.667 42.667 0 0 0 42.666 42.667H256A42.667 42.667 0 1 1 256 768h-42.667a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128V640a128 128 0 0 1-128 128H768a42.667 42.667 0 1 1 0-85.333h42.667A42.667 42.667 0 0 0 853.333 640V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zM298.667 384a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 384zM512 512a42.667 42.667 0 0 1 42.667 42.667v238.336l55.168-55.168a42.667 42.667 0 0 1 60.33 60.33l-128 128a42.667 42.667 0 0 1-60.33 0l-128-128a42.667 42.667 0 1 1 60.33-60.33l55.168 55.168V554.667A42.667 42.667 0 0 1 512 512z"
    />
  </svg>
);
export default SvgCoinRemovedIcon;
